export const CREDIT_CARD = {
  visa: require(asset`images/Purchase_Flow_Assets/visa.png`),
  mastercard: require(asset`images/Purchase_Flow_Assets/mastercard.png`),
  amex: require(asset`images/Purchase_Flow_Assets/amex.png`),
};

